<template>
	<div id="katalog-tiket">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Content</li>
      <li class="active">Content Section</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Konten</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right">
              <button type="button" class="btn btn-success btn-xs m-r-5" @click="createContentSection()"><span class="fa fa-plus"></span> Tambah Konten</button>
            </div>
            <h4 class="panel-title">List Content Section</h4>
          </div>
          <div class="panel-body">
						<app-datatable
							:items="KontenList"
							:has-action="true"
							:has-custom-pagination="true"
							:has-custom-search="true"
							:has-edit="true"
							:custom-pagination-current-page="pagination.currentPage"
							:custom-pagination-per-page="10"
							:custom-pagination-total-pages="pagination.totalPages"
							:custom-pagination-sort-mode="pagination.sortMode"
							:headers="headers"
              v-on:selected="selectedRow = $event"
							v-on:dblClicked="updateContent()"
              v-on:editNewTab="updateContentBtn($event)"
							v-on:deleted="deleteContent($event)"
							v-on:publishing="publish($event)"
							v-on:unpublishing="unpublish($event)"
							v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
						/>
          </div>
        </div>
      </div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import ContentService from '@/services/content.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'
import Moment from 'moment'

export default {
	name: 'katalog-tiket',
	components: {
		'app-datatable': DataTable,
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			isLoading: false,
			KontenList: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			type: {
				// SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
				// INSTANT_TRYOUT: 'INSTANT_TRYOUT',
				// CONSULTATION: 'CONSULTATION',
				// DUEL: 'DUEL',
				// ITEM_BANK: 'ITEM_BANK',
				// VIDEO: 'VIDEO'
			},
			headers: ['Judul', 'Type', 'Removeable?', 'Status'],
			headersKey: ['judul', 'type', 'is_removeable', 'status'],
      totalPage: 0
		}
	},
	mounted: function () {
		this.fetchData()
	},
	watch: {
		pagination: function () {
			this.fetchData()
		},
	},
	methods: {
		fetchData: function () {
			var context = this
			var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			}

			this.isLoading = true

			ContentService.getContentSectionList(pagination, search, function (result) {
				context.KontenList = []
				context.isLoading = false

				if (result.success) {
          if(pagination.currentPage > 1 && result.data.length < 1) {
            context.pagination.currentPage = parseInt(pagination.currentPage) - 1
            alert('Data hanya sampai halaman ' + context.pagination.currentPage)
            context.fetchData()
          } else if (pagination.currentPage === 1 && result.data.length === 0 ) {
            alert('Maaf, data belum ada ')
          }
					result.data.forEach(function (content) {
            var isRemovable = content.is_removable ? '' : '<i class="fa fa-times">'
						var row = {
							id: content.id,
							data: [
								content.name,
								content.type,
                isRemovable,
								content.status
							],
              status: content.status,
              order_number: content.order_number
						}
						context.pagination.totalPages = content.total_page
						context.KontenList.push(row)
					})
				} else {
					alert('Terjadi Kesalahan : ' + result.data.message)
				}
			})
		},
		createContentSection: function () {
			this.$router.push({ path: '/content/section-form' })
		},
		updateContent: function () {
			var contentid = this.selectedRow.id
      this.$store.commit('setEditDataContent', this.selectedRow)
			this.$router.push({ path: '/content/section-form', query: { id: contentid} })
		},
    updateContentBtn: function (data) {
      var contentid = data.id
      this.$store.commit('setEditDataContent', data)
			this.$router.push({ path: '/content/section-form', query: { id: contentid} })
    },
		deleteContent: function (content) {
			var context = this
			var contentID = content.id
			var confirmed = window.confirm("Apakah anda yakin akan menghapus konten section ini?")
			if (confirmed) {
				this.isLoading = true
				ContentService.deleteContentSection(contentID, function (result) {
					context.isLoading = false
					if (result.success) {
						alert('Data Terhapus')
						context.fetchData()
					} else {
						alert('Terjadi Kesalahan : ' + result.message)
					}
				})
			}
		},
    publish: function (content) {
      var context = this
      var confirmed = window.confirm("Apakah anda yakin akan PUBLISH konten section ini?")
			if (confirmed) {
        var form = {
                  name : content.data[0],
                  type : content.data[1],
                  is_active : false,
                  order_number: content.order_number,
                  status: 'PUBLISHED'
                }
        ContentService.contentSectionUpdate(content.id, form, function(result) {
          if(result.success) {
            alert('data telah dipublish')
            // this.fetchData()
            location.reload()
          }
        })
      }
    },
    unpublish: function (content) {
      var context = this
      var confirmed = window.confirm("Apakah anda yakin akan HIDDEN/UNPUBLISH konten section ini?")
			if (confirmed) {
        var form = {
              name : content.data[0],
              type : content.data[1],
              is_active : false,
              order_number: content.order_number,
              status: 'HIDDEN'
            }
        ContentService.contentSectionUpdate(content.id, form, function(result) {
          if(result.success) {
            alert('data telah disembunyikan')
            location.reload()
            // this.fetchData()
          }
        })
      }
    }
	}
}
</script>



// WEBPACK FOOTER //
// Content.vue?97323a44